'use strict';

const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const Router = require('balus/app/router/index');
const ContentTemplate = require('balus/ui/template/body/invitation/index.hbs');
const UserTemplate = require('balus/ui/template/body/account/user.hbs');
const InvitationTemplate = require('balus/ui/template/body/invitation/item.hbs');
const User = require('common/domain/entity/user');
const Ajax = require('common/infra/ajax');
const i18n = require('i18next');

function invitationAccept(userId, groupId, useV2) {
    const urlParams = new URLSearchParams(location.search);
    const token = urlParams.get('signup_token');

    Ajax.PUT(`/api/invitations/${token}/receive`, {id: userId}).then(() => {
        redirectToGroup(groupId);
    });
}

function redirectToGroup(groupId) {
    Router.navigate(`/groups/${groupId}`, {trigger: true});
}

const InvitationView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item',
    template: InvitationTemplate
});

const UserView = Mn.View.extend({
    tagName: 'li',
    className: 'list-item list-item-clickable',
    template: UserTemplate,
    events: {
        'click': 'click'
    },

    templateContext: function() {
        return {
            hideEmail: true
        }
    },

    click: function() {
        invitationAccept(this.model.id, this.getOption('groupId'), this.getOption('useV2'));
    }
});

const UserListView = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'list',
    childView: UserView,
    childViewOptions: function() {
        return {
            groupId: this.getOption('groupId'),
            useV2: this.getOption('useV2')
        }
    }
});

module.exports = Mn.View.extend({
    template: ContentTemplate,
    ui: {
        info: '.info',
        error: '.error'
    },
    regions: {
        invitation: '.invitation',
        accounts: '.accounts'
    },

    onRender: function() {
        const urlParams = new URLSearchParams(location.search);
        const token = urlParams.get('signup_token');
        if(!token) {
            this.error(i18n.t(`invitation:error.ObjectNotFoundError`));
            return;
        }

        Ajax.GET('/api/accounts').then(usersJson => {
            const users = new Backbone.Collection(usersJson, {
                model: User
            });

            Ajax.GET(`/api/invitations/${token}`).then(invitationJson => {
                if(!this.model) {
                    location.href = `/login?dst_url=${encodeURIComponent(location.pathname + location.search)}`;
                }

                const groupId = invitationJson.group.id;
                const useV2 = invitationJson.group.use_v2;

                if (invitationJson.user) {
                    // すでに招待を受諾済みなので、招待されたグループにリダイレクトする
                    redirectToGroup(groupId);
                    return;
                }

                this.showChildView('invitation', new InvitationView({
                    model: new Backbone.Model(invitationJson)
                }));

                // 紐付け可能なアカウントが1つだけの場合には、自動で招待を受諾する
                if (users.length === 1) {
                    const userId = users.at(0).id;
                    invitationAccept(userId, groupId, useV2);
                } else {
                    // 紐付け可能なアカウントが複数ある場合には、候補リストを表示する
                    this.showChildView('accounts', new UserListView({
                        collection: users,
                        groupId,
                        useV2
                    }));
                }
            }, reason => {
                // 対象の招待トークンが見つからない
                if(reason.type == 'ObjectNotFoundError') {
                    this.error(i18n.t(`invitation:error.${reason.type}`));
                }
            });
        }, () => {
            // ユーザ情報取得のエラー時には、ログインURLにリダイレクトする
            location.href = `/login?dst_url=${encodeURIComponent(location.pathname + location.search)}`;
        })


    },

    error: function(msg) {
        this.ui.info.hide();
        this.ui.error.html(msg);
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/invitation/index.js